"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerAreaMock = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
const headerAreaMock = exports.headerAreaMock = {
  header: {
    __typename: 'EditorialHeader',
    headline: 'Lorem ipsum dolor sit amet, sea te munere pertinax torquatos. cu sea odio son.',
    text: 'Vi anser att makeup bör förstärka din naturliga skönhet och samtidigt ge dig frihet att utrycka din sinnesstämning och personlighet. Vår makeupkollektion erbjuder dig levande, läckra färger, lekfullhet eller lyx och finess för ögon, ansikte, läppar och naglar.',
    publishedDate: '2023-09-04T09:55:00+00:00',
    imageUrl: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=f2ade014-b818-482b-8216-d1843729b1e7&name=0_LP_C1_Top_1366x280&inputFormat=jpg&bc=%239cdabc&ib=%239cdabc&h=560&q=95&imageFormat=WebP',
    isSharingEnabled: true,
    id: '123',
    backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite,
    headlineStorybookColor: _editorialFetching.StorybookColor.TextPrimary
  },
  breadcrumbs: [{
    ItemLabel: 'Breadcrumb 1',
    Url: '/breadcrumb1'
  }, {
    ItemLabel: 'Breadcrumb 2',
    Url: '/breadcrumb2'
  }, {
    ItemLabel: 'Breadcrumb 3',
    Url: '/breadcrumb3'
  }],
  debug: false,
  modulePosition: 0
};
